import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";

function BlogPost() {
  const { slug } = useParams();
  const [content, setContent] = useState("");
  const [meta, setMeta] = useState({});

  useEffect(() => {
    fetch(`/blog/${slug}.md`)
      .then((res) => res.text())
      .then((text) => {
        // extract frontmatter
        const frontmatterMatch = text.match(/---\n([\s\S]*?)\n---/);
        let metadata = {};
        let body = text;
        if (frontmatterMatch) {
          const lines = frontmatterMatch[1].split("\n");
          lines.forEach((line) => {
            const [key, ...rest] = line.split(":");
            metadata[key.trim()] = rest.join(":").trim().replace(/"/g, "");
          });
          body = text.replace(frontmatterMatch[0], ""); // remove frontmatter
        }
        setMeta(metadata);
        setContent(body);
      });
  }, [slug]);

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      {meta.caption && (
        <img
          src={meta.caption}
          alt={meta.title}
          className="w-full h-64 object-cover rounded-lg mb-6"
        />
      )}
      <h1 className="text-4xl font-bold mb-2">{meta.title}</h1>
      <p className="text-black mb-8">{meta.date}</p>
      <ReactMarkdown className="prose prose-lg text-black">{content}</ReactMarkdown>
    </div>
  );
}

export default BlogPost;
